<template>
    <div class="forgot-password-container">
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    import { RouteName } from '@app/router/constants/RouteName';
    import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
    import { getAccountConfig } from '@accountFederation/config/accountConfig';
    import { SecurityCheckModalsGroup } from '@accountFederation/modules/securityCheck/faceId/mfaFlows';

    export default {
        name: 'ForgotPassworContainer',
        mounted() {
            this.setModal({
                code: modalCodes.forgotPassword,
                data: {
                    redirect: RouteName.App.Home,
                },
                ...(getAccountConfig().isForgotPasswordSecurityCheckEnabled && { group: SecurityCheckModalsGroup }),
                afterClose: this.goToLanding(),
            });
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            goToLanding() {
                this.$router.replace({
                    name: RouteName.App.Home,
                });
            },
        },
    };
</script>
